module.exports = __webpack_public_path__ + "img/shandian.53504bac.png";